export default __webpack_public_path__ + "static/media/Google_Chrome_Web_Store_icon_2015.9f032014.svg";